import Movie from './Movie'

export default Movie
// eslint-disable-next-line import/export
export * from './Movie'
